import React from 'react';
import {Modal} from 'react-bootstrap';
import {ReportClip} from '../../../../types/Api/Reports';
import {TwitchClip} from 'react-twitch-embed';
import css from './ReportsV2ViewClipModal.module.scss';

export type ReportsV2ViewClipModalProps = {
  clip?: ReportClip | null;
  onClose: () => void;
};

export const ReportsV2ViewClipModal = ({
  clip,
  onClose,
}: ReportsV2ViewClipModalProps) => {
  const clipUrl = clip?.clipUrl?.split('/').pop() || '';

  return (
    <Modal
      show={!!clip}
      onHide={onClose}
      centered
      size="lg"
      contentClassName={css.modal}
    >
      <TwitchClip clip={clipUrl} autoplay width="100%" />
    </Modal>
  );
};
